import React from "react";

const ConfirmModal = ({
  title = "Confirm action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: 10,
          width: "100%",
          maxWidth: 420,
          padding: "20px 22px 18px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
          animation: "modalFadeIn 0.2s ease-out",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            margin: "0 0 12px",
            fontSize: 18,
            fontWeight: 600,
            color: "var(--background-colour)",
          }}
        >
          {title}
        </h3>

        <div
          style={{
            fontSize: 16,
            color: "#222",
            lineHeight: 1.5,
            marginBottom: 20,
          }}
        >
          {message}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <button
            onClick={onCancel}
            disabled={loading}
            style={{
              padding: "8px 14px",
              borderRadius: 6,
              border: "1px solid #ccc",
              background: "#f5f5f5",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.6 : 1,
              fontFamily: "inherit",
            }}
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: "8px 14px",
              borderRadius: 6,
              border: "none",
              background: "#c0392b",
              color: "#fff",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.6 : 1,
              fontFamily: "inherit",
            }}
          >
            {loading ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
